// import { LogSourceType, LogEnvType } from '@/data/log/index';
// import { API_BASE } from '@/config';
import types from '../types/analyze';

const SERVER_NAME_KEY = 'apm_server';

const analyze = {
  namespaced: true,
  state: {
    serverName: sessionStorage.getItem(SERVER_NAME_KEY) || '',
  },
  getters: {
  },
  actions: {
  },
  mutations: {
    [types.SET_SERVER_NAME]: (state, name) => {
      sessionStorage.setItem(SERVER_NAME_KEY, name);
      state.serverName = name;
    },
  },
};

export default analyze;
